import Vue from 'vue'
import Vuex from 'vuex'
import errorLog from './modules/errorLog'
import common from './common'
import meituanIM from './meituanIM'
import cs from './cs'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    common,
    errorLog,
    meituanIM,
    cs
  }
})



// WEBPACK FOOTER //
// ./src/js/conf/home/store/index.js